import React from 'react';
import { useTranslation } from '~/behaviors/languages';
import { mui } from '~/tools/mui';
import UIRoutes from './UI.routes';
import UINotifications from './Ui.notifications.tsx';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { datetime } from '../tools/datetime';
import { config } from '@worktango/ai-assistant/react';
import { getAccessToken } from '~/adapters/tokens';

import { CustomErrorBoundary } from './UI.shared/CustomErrorBoundary';

const UILayout: React.FC = () => {
  // ------------------------------------------------------------------ State --

  const { i18n } = useTranslation();
  const language = i18n.language;

  // Configure global bearer token strategy for @worktango/ai-assistant components
  React.useEffect(() => {
    config.setPulseBearerTokenStrategy(() => getAccessToken() ?? '');
  }, []);

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={datetime.findDateLocale(language)}>
        <mui.CssBaseline />

        <CustomErrorBoundary>
          <UIRoutes />
        </CustomErrorBoundary>

        <UINotifications />
      </LocalizationProvider>
    </>
  );
};

export default UILayout;
